<template>
  <div class="main__content research-file">
    <div class="research-file__section">
      <h5
        class="research-file__field-title"
        :class="{ required_el: !isEdit }"
      >
        {{ $t('main.research_file_name') }}
      </h5>
      <text-field v-model="name" :is-error="$v.type.$error" />
    </div>
    <div class="research-file__section">
      <h5
        class="research-file__field-title"
        :class="{ required_el: !isEdit }"
      >
        {{ $t('main.research_file_type') }}
      </h5>
      <select-field
        v-model="type"
        :items="optionsType"
        titleKey="name"
        valueToReturn="object"
        :placeholder="$t('main.research_file_type')"
        isObjectType
        :is-error="$v.name.$error"
      />
    </div>
    <div class="research-file__section">
      <h4
        class="title-h4 research-file__title"
        :class="{ required_el: !isEdit }"
      >
        {{ $t('main.import_research_file') }}
      </h4>
      <FileUpload
        v-model="file"
        :max-size-k-b="fileMaxSize"
        :valid-formats="validFormats"
        :is-error="$v.file.$error"
        class="research-file__file-upload"
      />
    </div>

    <div class="research-file__buttons-block">
      <template v-if="isEdit">
        <Button
          transparent
          class="research-file__button"
          @click.native="
            $router.push({ name: 'content-administrator_research-files-list' })
          "
        >
          {{ $t('buttons.cancel') }}
        </Button>
        <Button class="research-file__button" @click.native="save"
          >{{ $t('buttons.make_improvement') }}
        </Button>
      </template>
      <template v-else>
        <Button
          class="research-file__button"
          icon-name="arrow"
          isRightIcon
          @click.native="save"
          >{{ $t('buttons.create') }}
        </Button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { createFile } from '@/library/helpers';
import FileUpload from '@/elements/FileUpload.vue';
import SelectField from '@/elements/SelectField.vue';

export default {
  components: { FileUpload, SelectField },

  data() {
    return {
      name: '',
      type: '',
      file: null,
      validFormats: ['pdf'],
      fileMaxSize: 5000,
    };
  },

  async created() {
    !!!this.$route.params.activity &&
      this.$router.push({ name: 'content-administrator_research-files-list' });

    if (this.isEdit) {
      await this.$store.dispatch(
        'getResearchFileContentAdmin',
        this.$route.params.id
      );
      await this.getCurrentResearchFile();
    }
  },

  computed: {
    ...mapGetters(['getCurrentResearchFileAdmin', 'getStatisticPages']),

    isEdit() {
      return this.$route.params.activity === 'edit';
    },

    getDataForSave() {
      let data = new FormData();
      !!this.name.length && data.append('title', this.name);
      !!this.file?.length && data.append('attachment', this.file[0]);
      !!this.$route.params?.id && data.append('uuid', this.$route.params.id);
      !!this.type && data.append('type', this.type.type);
      return data;
    },

    optionsType() {
      return this.getStatisticPages.map(el => {
        el.name = this.$t(`statistic.${el.type}`)

        return el
      })
    },
  },

  methods: {
    async getCurrentResearchFile() {
      this.name = this.getCurrentResearchFileAdmin.title;
      this.type = this.getStatisticPages.find(el => el.type === this.getCurrentResearchFileAdmin.type);
      this.file = [
        await createFile(
          this.getCurrentResearchFileAdmin.attachment.original_url,
          this.getCurrentResearchFileAdmin.attachment.mime
        ),
      ];
    },

    save() {
      if (this.isEdit) {
        this.$store.dispatch(
          'updateResearchFileContentAdmin',
          this.getDataForSave
        );
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.$store.dispatch(
            'createResearchFileContentAdmin',
            this.getDataForSave
          );
        }
      }
    },
  },

  validations: {
    name: {
      required,
    },
    type: {
      required,
    },
    file: {
      required,
    },
  },
};
</script>

<style lang="sass" scoped>
.research-file__section
  margin-bottom: 10rem
.research-file__field-title
  color: $draft
  font-size: 16px
  font-weight: 300
  margin-bottom: 10px
  margin-top: 50px
.research-file__title
  margin-bottom: 40px
  @include xxs
    line-height: 24px

.research-file__file-upload
  width: 30%
  min-width: 350px
  @include xxs
    min-width: 100%
.research-file__buttons-block
  display: flex
  justify-content: flex-end
  padding-bottom: 50px
  @include xs
    justify-content: center
  @include xxs
    flex-direction: column
    align-items: center

.research-file__button
  @include xs
    min-width: 220px
  @include xxs
    min-width: 290px
  &:first-child
    margin-right: 20px
    @include xxs
      margin: 0 0 20px 0
</style>
